<script>
import sl from "@/Prevodi/WeightBalance-sl.json";
import en from "@/Prevodi/WeightBalance-en.json";
import it from "@/Prevodi/WeightBalance-it.json";
import {i18n} from "@/i18n";
import Multiselect from "vue-multiselect";
import Notification from "@/components/reUse/Notification.vue";
import Chart from "chart.js/auto";

export default {
  name: "WeightBalance",
  components: {Notification, Multiselect},
  data() {
    return {
      prenos: false,
      prevodi: false,
      lahkoIzracuna: false,
      enotaMere: 'kg',
      letala: [],
      izbranoLetalo: null,
      wb: {
        teza: 0,
        pilot: 0,
        gorivo: 0,
        potniki: 0,
        prtljaga: 0
      },
      cg_limit_min: '',
      cg_limit_max: '',
      max_masa: '',
      max_gorivo: 0,
      max_prtljaga: 0,
      arm_gorivo: '',
      arm_masa: '',
      arm_prednji_sedez: '',
      arm_zadnji_sedez: '',
      arm_prtljaga: '',
      lbs: 0.453592,
      galVliter: 3.7854,
      literVKg: 0.72,
      prikaziGraf: false,
      //obvestila
      text: '',
      types: '',
      ShowNoti: false
    }
  },
  computed: {
    skupnaTeza() {
      if (this.enotaMere === 'kg') {
        const gVKg = (masa, pretvornik) =>
            (masa * pretvornik) || 0;
        return (
            (this.wb.teza / this.lbs || 0) +
            (this.wb.pilot / this.lbs || 0) +
            (this.wb.potniki / this.lbs || 0) +
            (gVKg(this.wb.gorivo, this.literVKg) / this.lbs || 0) +
            (this.wb.prtljaga / this.lbs || 0)
        );
      } else {
        const gVKg = (masa, galon, pretvornik) =>
            ((Number(masa) * Number(galon)) * Number(pretvornik)) || 0;
        return (
            (this.wb.teza || 0) +
            (this.wb.pilot || 0) +
            (this.wb.potniki || 0) +
            (gVKg(this.wb.gorivo, this.galVliter, this.literVKg) / this.lbs || 0) +
            (this.wb.prtljaga || 0)
        );
      }
    },
    skupnaTezaKg() {
      if (this.enotaMere === 'kg') {
        const gVKg = (masa, pretvornik) =>
            (masa * pretvornik) || 0;
        return (
            (this.wb.teza || 0) +
            (this.wb.pilot || 0) +
            (this.wb.potniki || 0) +
            (gVKg(this.wb.gorivo, this.literVKg) || 0) +
            (this.wb.prtljaga || 0)
        );
      } else {
        const gVKg = (masa, galon, pretvornik) =>
            ((Number(masa) * Number(galon)) * Number(pretvornik)) || 0;
        return (
            (this.wb.teza * this.lbs || 0) +
            (this.wb.pilot * this.lbs || 0) +
            (this.wb.potniki * this.lbs || 0) +
            (gVKg(this.wb.gorivo, this.galVliter, this.literVKg) || 0) +
            (this.wb.prtljaga * this.lbs || 0)
        );
      }
    },
    skupniMoment() {
      if (!this.lahkoIzracuna || !this.lbs) {
        return 0;
      }
      if (this.enotaMere === 'kg') {
        const moment = (masa, arm) =>
            Math.round((Number(masa)) * Number(arm)) || 0;
        const gVKg = (masa, pretvornik) =>
            (Number(masa) * Number(pretvornik)) || 0;
        return (
            moment(this.wb.teza, this.arm_masa) +
            moment(this.wb.pilot, this.arm_prednji_sedez) +
            moment(this.wb.potniki, this.arm_zadnji_sedez) +
            moment(gVKg(this.wb.gorivo, this.literVKg), this.arm_gorivo) +
            moment(this.wb.prtljaga, this.arm_prtljaga)
        );
      } else {
        const moment = (masa, arm) =>
            Math.round((Number(masa)) * Number(arm)) || 0;
        const gVKg = (masa, galon, pretvornik) =>
            ((Number(masa) * Number(galon)) * Number(pretvornik)) || 0;
        return (
            moment(this.wb.teza, this.arm_masa) +
            moment(this.wb.pilot, this.arm_prednji_sedez) +
            moment(this.wb.potniki, this.arm_zadnji_sedez) +
            moment(gVKg(this.wb.gorivo, this.galVliter, this.literVKg) / this.lbs, this.arm_gorivo) +
            moment(this.wb.prtljaga, this.arm_prtljaga)
        );
      }
    },
    CGIzracun() {
      if (this.enotaMere === 'kg') {
        return this.skupniMoment / this.skupnaTezaKg || 0;
      }
      return this.skupniMoment / this.skupnaTeza || 0;

    },
    MasaIzracun() {
      if (this.enotaMere === 'kg') {
        return this.skupnaTezaKg / this.max_masa;
      }
      return this.skupnaTeza / this.max_masa;
    },
    VrniSkupno() {
      this.Graf();
      if (this.enotaMere === 'kg') {
        return this.skupnaTezaKg;
      }
      return this.skupnaTeza;
    }
  },
  watch: {
    izbranoLetalo(novo) {
      if (novo && novo.cg_limit_min !== null) {
        this.cg_limit_min = novo.cg_limit_min;
        this.cg_limit_max = novo.cg_limit_max;
        this.max_masa = novo.max_masa;
        this.arm_gorivo = novo.arm_gorivo;
        this.arm_masa = novo.arm_masa;
        this.arm_prednji_sedez = novo.arm_prednji_sedez;
        this.arm_zadnji_sedez = novo.arm_zadnji_sedez;
        this.arm_prtljaga = novo.arm_prtljaga;
        this.max_gorivo = novo.max_gorivo;
        this.max_prtljaga = novo.max_prtljaga;
        this.enotaMere = novo.enota_mase;
        this.lahkoIzracuna = true;
        this.wb.teza = this.enotaMere === 'kg' && this.izbranoLetalo.enota_mase === 'kg' ? Number(novo.masa_plovila) :
            this.enotaMere === 'kg' && this.izbranoLetalo.enota_mase === 'lbs' ? Number((Number(novo.masa_plovila) * this.lbs).toFixed(2)) :
                Number(novo.masa_plovila);
      } else {
        this.lahkoIzracuna = false;
      }
    },
    enotaMere(stara, nova) {
      if (stara !== nova) {
        this.wb = {
          teza: this.enotaMere === 'kg' && this.izbranoLetalo.enota_mase === 'kg' ? Number(this.izbranoLetalo.masa_plovila) :
              this.enotaMere === 'kg' && this.izbranoLetalo.enota_mase === 'lbs' ? Number((Number(this.izbranoLetalo.masa_plovila) * this.lbs).toFixed(2)) :
                  (Number(this.izbranoLetalo.masa_plovila)),
          pilot: 0,
          gorivo: 0,
          potniki: 0,
          prtljaga: 0
        };
      }
    },
    wb: {
      deep: true,
      handler(novo) {
        if (novo.prtljaga > Number(this.max_prtljaga)) {
          this.text = 'Vnesena teža presega maksimalno težo. Vrednost nastavljena na najvišjo možno.'
          this.types = "Napaka";
          this.ShowNoti = true;
          novo.prtljaga = Number(this.max_prtljaga)
        }
        if (novo.gorivo > Number(this.max_gorivo)) {
          this.text = 'Vnesena količina presega maksimalno količino goriva. Vrednost nastavljena na najvišjo možno.'
          this.types = "Napaka";
          this.ShowNoti = true;
          novo.gorivo = Number(this.max_gorivo);
        }
      }
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.BeriLetala();
  },
  methods: {
    async BeriLetala() {
      await axios.get('./api/sifranti/letala/izpis/', {withCredentials: true}).then((response) => {
        this.letala = response.data.letala;
      });
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    PrenosPDF() {
      this.prenos = true;
      this.wb.gorivo_teza = this.enotaMere === 'kg' ? ((this.wb.gorivo * this.literVKg)).toFixed(2) : (((this.wb.gorivo * this.galVliter) * this.literVKg) * this.lbs).toFixed(2);
      this.wb.gorivo_enota = this.enotaMere === 'kg' ? 'kg' : 'lbs';
      let graf = document.getElementById('wb_graf').toDataURL("image/png");
      let podatki = {
        registracija: this.izbranoLetalo.registracija,
        enota: this.enotaMere === 'kg' ? 'kg' : 'lbs',
        wb: this.wb,
        cgi: {
          min: this.izbranoLetalo.cg_limit_min,
          max: this.izbranoLetalo.cg_limit_max,
          izracun: this.CGIzracun.toFixed(2)
        },
        moment: {
          letalo: ((this.wb.teza) * this.arm_masa).toFixed(2),
          pilot: ((this.wb.pilot) * this.arm_prednji_sedez).toFixed(2),
          potniki: ((this.wb.potniki) * this.arm_zadnji_sedez).toFixed(2),
          prtljaga: ((this.wb.prtljaga) * this.arm_prtljaga).toFixed(2),
          gorivo: this.enotaMere === 'kg' ? (((this.wb.gorivo * this.literVKg)) * this.arm_gorivo).toFixed(2) : ((((this.wb.gorivo * this.galVliter) * this.literVKg) / this.lbs) * this.arm_gorivo).toFixed(2),
          skupaj: this.skupniMoment.toFixed(2),
        },
        sMasa: (this.MasaIzracun * 100).toFixed(2),
        max_masa: this.izbranoLetalo.max_masa,
        skupna_teza: this.VrniSkupno.toFixed(2),
        graf_slika: this.prikaziGraf ? graf : null
      }
      let klic = new URLSearchParams();

      //this.dataURItoBlob(graf)
      klic.append('podatki', JSON.stringify(podatki));
      // klic.append('graf', this.dataURItoBlob(graf), 'graf.png');
      axios.post('./api/briefing/pdf/', klic, {withCredentials: true, responseType: 'blob'}).then((response) => {
        this.prenos = false;
        const blob = new Blob([response.data], {type: 'application/pdf'});
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      }).catch((napaka) => {
        this.prenos = false;
        this.text = napaka
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    ArrayStevilk(zacetna, koncna) {
      return Array.from(
          {length: Math.floor((koncna - zacetna) / 10) + 1},
          (_, i) => zacetna + i * 10
      );
    },
    Graf() {
      if (this.izbranoLetalo.wgt_1 === null || this.izbranoLetalo.wgt_2 === null || this.izbranoLetalo.wgt_3x === null || this.izbranoLetalo.wgt_3y === null || this.izbranoLetalo.wgt_4 === null || this.izbranoLetalo.wgt_5 === null) {
        this.text = "Grafa ni možno narisati, ker manjkajo podatki za wgt1-5. Obvestite upravitelja, da za to plovilo doda podatke wgt-ja.";
        this.types = "Napaka";
        this.ShowNoti = true;
        const canvas = document.getElementById('wb_graf');
        // Uničimo obstoječi graf, če že obstaja
        const obstojeciGraf = Chart.getChart(canvas);
        if (obstojeciGraf) {
          obstojeciGraf.destroy();
        }
        this.prikaziGraf = false;
        return;
      }
      this.prikaziGraf = true;
      const canvas = document.getElementById('wb_graf');

      // Uničimo obstoječi graf, če že obstaja
      const obstojeciGraf = Chart.getChart(canvas);

      if (obstojeciGraf) {
        obstojeciGraf.destroy();
      }

      const ctx = canvas.getContext('2d');

      canvas.width = 300;
      canvas.height = 200;

      const zacetna_limit = (Math.floor(Number(this.izbranoLetalo.cg_limit_min) / 10) * 10) - 10; //generiranje okrogle številke 10 mest od cg_limit_min
      const koncna_limit = (Math.floor(Number(this.izbranoLetalo.cg_limit_max) / 10) * 10) + 10; //generiranje okrogle številke 10 mest od cg_limit_max
      const max_letala = (Math.floor(Number(this.izbranoLetalo.max_masa) / 10) * 10) + 10
      const masa_letala = (Math.floor(Number(this.izbranoLetalo.masa_plovila) / 10) * 10) + 20

      const labels = this.ArrayStevilk(zacetna_limit, koncna_limit);
      const zacetni_arm = Number(this.wb.teza * this.arm_masa).toFixed(2);
      const prvi_sedez_arm = Number(this.wb.pilot * this.izbranoLetalo.arm_prednji_sedez).toFixed(2);
      const zadnji_sedez_arm = Number(this.wb.potniki * this.izbranoLetalo.arm_zadnji_sedez).toFixed(2);
      const prtljaga_arm = Number(this.wb.prtljaga * this.izbranoLetalo.arm_prtljaga).toFixed(2);
      const gorivo_teza = this.enotaMere === 'kg' ? ((this.wb.gorivo * this.literVKg)).toFixed(2) : (((this.wb.gorivo * this.galVliter) * this.literVKg) * this.lbs).toFixed(2);
      const gorivo_arm = Number(gorivo_teza * this.izbranoLetalo.arm_gorivo).toFixed(2);

      const masaPlovila = Number(this.izbranoLetalo.masa_plovila);
      const masaPilota = Number(this.wb.pilot);
      const masaPotnikov = Number(this.wb.potniki);
      const masaPrtljage = Number(this.wb.prtljaga);

      const armZacetni = Number(zacetni_arm);
      const armPrviSedez = Number(prvi_sedez_arm);
      const armPrtljaga = Number(prtljaga_arm);
      let podatki_pilot = [];
      let podatki_gorivo = [];
      if (this.izbranoLetalo.ima_zadnji_sedez) {
        const armZadnjiSedez = Number(zadnji_sedez_arm);
        const masaPilot = masaPlovila + masaPilota;
        const masaPotniki = masaPilot + masaPotnikov;
        const masaSkupaj = masaPotniki + masaPrtljage;
        const armPilot = armZacetni + armPrviSedez;
        const armPotniki = armPilot + armZadnjiSedez;
        const armSkupaj = armPotniki + armPrtljaga;
        const masaZGorivom = masaSkupaj + Number(gorivo_teza);
        const armZGorivom = armSkupaj + Number(gorivo_arm);
        podatki_pilot = [
          {
            y: masaPlovila,
            x: Number(this.arm_masa),
          },
          {
            y: masaPilot,
            x: armPilot / masaPilot,
          },
          {
            y: masaPotniki,
            x: armPotniki / masaPotniki,
          },
          {
            y: masaSkupaj,
            x: armSkupaj / masaSkupaj,
          },
        ];
        podatki_gorivo = [
          {
            y: masaSkupaj,
            x: armSkupaj / masaSkupaj,
          },
          {
            y: masaZGorivom,
            x: armZGorivom / masaZGorivom,
          },
        ];
      } else {
        const masaPilot = masaPlovila + masaPilota;
        const masaSkupaj = masaPilot + masaPotnikov + masaPrtljage;
        const armPilot = armZacetni + armPrviSedez;
        const armSkupaj = armPilot + armPrtljaga;
        const masaZGorivom = masaSkupaj + Number(gorivo_teza);
        const armBrezZadnjegaSedeza =
            Number(zacetni_arm) +
            Number(prvi_sedez_arm) +
            Number(prtljaga_arm);

        const armBrezZadnjegaSedezaZGorivom =
            armBrezZadnjegaSedeza + Number(gorivo_arm);
        podatki_pilot = [
          {
            y: masaPlovila,
            x: Number(this.arm_masa),
          },
          {
            y: masaPilot,
            x: armPilot / masaPilot,
          },
          {
            y: masaSkupaj,
            x: armSkupaj / masaSkupaj,
          },
        ];

        podatki_gorivo = [
          {
            y: masaSkupaj,
            x: armBrezZadnjegaSedeza / masaSkupaj,
          },
          {
            y: masaZGorivom,
            x: armBrezZadnjegaSedezaZGorivom / masaZGorivom,
          },
        ];
      }

      const povp_masa_plovila = Number((Number(this.izbranoLetalo.max_masa) + Number(this.izbranoLetalo.masa_plovila)) / 2);
      const povp_limit_letala = Number(Number(Number(this.izbranoLetalo.cg_limit_min) + Number(this.izbranoLetalo.cg_limit_max)) / 2) - 20;
      const obroba = [
        {
          x: Number(this.izbranoLetalo.cg_limit_min),
          y: Number(this.izbranoLetalo.wgt_1)
        },
        {
          x: Number(this.izbranoLetalo.cg_limit_min),
          y: Number(this.izbranoLetalo.wgt_2)
        },
        {
          x: Number(this.izbranoLetalo.wgt_3y), //prej povp_limit_letala
          y: Number(this.izbranoLetalo.wgt_3x) //prej na max_masa
        }, {
          x: Number(this.izbranoLetalo.cg_limit_max),
          y: Number(this.izbranoLetalo.wgt_4) //prej na max_masa
        },
        {
          x: Number(this.izbranoLetalo.cg_limit_max),
          y: Number(this.izbranoLetalo.wgt_5)
        }
      ];
      const data = {
        datasets: [
          {
            label: 'Mejna vrednost',
            data: obroba,
            showLine: true, // mora biti zaradi povezave točk
            borderColor: "#ff6347",
            backgroundColor: "#d68f83",
            yAxisID: 'y',
          },
          {
            label: 'Pilot',
            data: podatki_pilot,
            showLine: true, // mora biti zaradi povezave točk
            borderColor: "#0a52f0",
            backgroundColor: "#839dd6",
            yAxisID: 'y',
          },
          {
            label: 'Gorivo',
            data: podatki_gorivo,
            showLine: true, // mora biti zaradi povezave točk
            borderColor: "#30ae3b",
            backgroundColor: "#30ae3b",
            yAxisID: 'y',
          }
        ]
      };
      const config = {
        type: 'scatter',
        data: data,
        options: {
          responsive: true,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          stacked: false,
          plugins: {
            title: {
              display: true,
              text: 'W&B Graf'
            }
          },
          scales: {
            x: {
              type: 'linear',
              min: zacetna_limit,
              max: koncna_limit,
              ticks: {
                stepSize: 10
              },
              display: true,
              position: 'left',
            },
            y: {
              type: 'linear',
              min: masa_letala,
              max: max_letala,
              ticks: {
                stepSize: 10
              },
              display: true,
              position: 'left',
            }
          }
        },
      };
      const chart = new Chart(ctx, config);
    },
    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      let byteString = atob(dataURI.split(',')[1]);
      // separate out the mime component
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      // write the bytes of the string to an ArrayBuffer
      let ab = new ArrayBuffer(byteString.length);
      // create a view into the buffer
      let ia = new Uint8Array(ab);
      // set the bytes of the buffer to the correct values
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      // write the ArrayBuffer to a blob, and you're done
      return new Blob([ab], {type: mimeString});
    },
  }

}
</script>

<template>
  <div v-if="prevodi" class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{ $t('main.nazaj') }}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{ $t('main.title') }}</h1>
        </div>
      </div>
    </div>
  </div>
  <main class="mt-4">
    <div class="container-fluid">
      <div class="row justify-content-center align-items-stretch">
        <div class="col-12 col-lg-8 col-xl-6">

          <div class="card shadow-sm bg-dark text-light border-secondary h-100">

            <div class="card-header bg-dark text-light border-secondary d-flex justify-content-between">
              <h5 class="mb-0">
                <i class="fas fa-calculator"></i>
                Masa in težišče
              </h5>
              <div v-if="lahkoIzracuna">
                <button class="btn btn-outline-light" :disabled="!wb.pilot > 0 || prenos" @click="PrenosPDF">
                  <i class="fas fa-file-pdf" :class="{'fa-spin fa-spinner': prenos}"></i> Pdf izračuna
                </button>
              </div>
            </div>

            <div class="card-body">

              <div class="row g-3">
                <div class="col-6">
                  <multiselect v-model="izbranoLetalo"
                               :deselectLabel="$t('labelswb.odstrani')"
                               :options="letala"
                               :placeholder="$t('labelswb.isci')"
                               :selectLabel="$t('labelswb.izberi')"
                               :selectedLabel="$t('labelswb.izbrano')"
                               class="mt-2 mb-2 wingsi-multiselect"
                               label="registracija"
                               track-by="registracija"
                  >
                    <template #noResult>
                      {{ $t('labelswb.neObstaja') }}
                    </template>
                    <template #noOptions>
                      {{ $t('labelswb.praznaLista') }}
                    </template>
                  </multiselect>
                </div>
                <div class="col-6 text-end" v-if="lahkoIzracuna">
                  <label class="w-100 form-label fw-bold">
                    Vnos v
                  </label>
                  <div class="btn-group" role="group" aria-label="Izbira enote mere">
                    <input
                        id="enotaKg"
                        v-model="enotaMere"
                        disabled
                        class="btn-check"
                        type="radio"
                        value="kg"
                    >
                    <label
                        class="btn btn-outline-light"
                        for="enotaKg"
                    >
                      EU
                    </label>

                    <input
                        id="enotaLbs"
                        v-model="enotaMere"
                        disabled
                        class="btn-check"
                        type="radio"
                        value="lbs"
                    >
                    <label
                        class="btn btn-outline-light"
                        for="enotaLbs"
                    >
                      USA
                    </label>

                  </div>

                </div>
                <!-- Teža letala -->
                <div v-if="lahkoIzracuna">
                  <div class="col-12">
                    <div class="d-flex gap-2 justify-content-between">
                      <label class="w-100 form-label fw-bold">
                        {{ $t('obrazec.labels.tezaLetalo') }} {{ enotaMere === 'kg' ? '(kg)' : '(lbs)' }}
                      </label>
                      <label class="w-100 form-label fw-bold text-end" v-if="enotaMere !== 'kg'">
                        {{ $t('obrazec.labels.izpisTeze') }} {{ enotaMere === 'kg' ? '(lbs)' : '(kg)' }}
                      </label>
                      <label class="w-100 form-label fw-bold text-end">
                        {{ $t('obrazec.labels.izpisMomenta') }} ({{ enotaMere === 'kg' ? 'cm-kg' : 'in-lbs' }})
                      </label>
                    </div>
                    <div class="d-flex gap-2 justify-content-between">
                      <div class="w-100 modern-input-group disabled">
                        <input
                            v-model.number="wb.teza"
                            disabled
                            class="form-control bg-dark text-light border-secondary"
                        >
                      </div>
                      <div class="w-100 d-flex gap-1 justify-content-between">
                        <div class="w-100 modern-input-group" v-if="enotaMere !== 'kg'">
                          <input
                              :value="enotaMere === 'kg' ? (wb.teza/lbs).toFixed(2) : (wb.teza*lbs).toFixed(2)"
                              class="form-control bg-warning text-dark border-light"
                              disabled
                          >
                        </div>
                        <div class="w-100 modern-input-group">
                          <input
                              :value="enotaMere === 'kg' ? ((wb.teza)*arm_masa).toFixed(2) : ((wb.teza)*arm_masa).toFixed(2)"
                              class="form-control  border-secondary"
                              :class="{'bg-warning text-dark': enotaMere === 'kg', 'bg-dark text-light': enotaMere !== 'kg'}"
                              disabled
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Pilot + prednji sedež -->
                  <div class="col-12">
                    <label class="form-label fw-bold">
                      {{ $t('obrazec.labels.pilot') }} {{ enotaMere === 'kg' ? '(kg)' : '(lbs)' }}
                    </label>
                    <div class="d-flex gap-2 justify-content-between">
                      <div class="w-100 modern-input-group">
                        <input
                            v-model.number="wb.pilot"
                            :disabled="!lahkoIzracuna"
                            class="form-control bg-dark text-light border-secondary"
                            min="0"
                            placeholder="0.0"
                            step="0.1"
                            type="number"
                        >
                      </div>
                      <div class="w-100 d-flex gap-1 justify-content-between">
                        <div class="w-100 modern-input-group" v-if="enotaMere !== 'kg'">
                          <input
                              :value="enotaMere === 'kg' ? (wb.pilot/lbs).toFixed(2) : (wb.pilot*lbs).toFixed(2)"
                              class="form-control bg-warning text-dark border-light"
                              disabled
                          >
                        </div>
                        <div class="w-100 modern-input-group">
                          <input
                              :value="enotaMere === 'kg' ? ((wb.pilot)*arm_prednji_sedez).toFixed(2) : (wb.pilot*arm_prednji_sedez).toFixed(2)"
                              class="form-control border-secondary"
                              :class="{'bg-warning text-dark': enotaMere === 'kg', 'bg-dark text-light': enotaMere !== 'kg'}"
                              disabled
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Sopotniki -->
                  <div class="col-12" v-if="izbranoLetalo.ima_zadnji_sedez">
                    <label class="form-label fw-bold">
                      {{ $t('obrazec.labels.sopotniki') }} {{ enotaMere === 'kg' ? '(kg)' : '(lbs)' }}
                    </label>
                    <div class="d-flex gap-2 justify-content-between">
                      <div class="w-100 modern-input-group">
                        <input
                            v-model.number="wb.potniki"
                            :disabled="!lahkoIzracuna"
                            class="form-control bg-dark text-light border-secondary"
                            min="0"
                            placeholder="0.0"
                            step="0.1"
                            type="number"
                        >
                      </div>
                      <div class="w-100 d-flex gap-1 justify-content-between">
                        <div class="w-100 modern-input-group" v-if="enotaMere !== 'kg'">
                          <input
                              :value="enotaMere === 'kg' ? (wb.potniki/lbs).toFixed(2) : (wb.potniki*lbs).toFixed(2)"
                              class="form-control bg-warning text-dark border-light"
                              disabled
                          >
                        </div>
                        <div class="w-100 modern-input-group">
                          <input
                              :value="enotaMere === 'kg' ? ((wb.potniki)*arm_zadnji_sedez).toFixed(2) : (wb.potniki*arm_zadnji_sedez).toFixed(2)"
                              class="form-control bg-dark text-light border-secondary"
                              :class="{'bg-warning text-dark': enotaMere === 'kg', 'bg-dark text-light': enotaMere !== 'kg'}"
                              disabled
                          >
                        </div>
                      </div>

                    </div>

                  </div>

                  <!-- GORIVO -->
                  <div class="col-12">
                    <label class="form-label fw-bold">
                      {{ $t('obrazec.labels.gorivo') }} {{ enotaMere === 'kg' ? '(L)' : '(Gal)' }}
                    </label>
                    <div class="d-flex gap-2 justify-content-between">
                      <div class="w-100 modern-input-group">
                        <input
                            v-model.number="wb.gorivo"
                            :disabled="!lahkoIzracuna"
                            class="form-control bg-dark text-light border-secondary"
                            min="0"
                            :max="max_gorivo"
                            placeholder="0.0"
                            step="0.1"
                            type="number"
                        >
                        <input
                            disabled
                            :value="enotaMere === 'kg' ? ((wb.gorivo*literVKg)).toFixed(2) + 'kg' : (((wb.gorivo*galVliter)*literVKg)*lbs).toFixed(2) +'lbs'"
                            class="form-control bg-dark text-light border-secondary"
                            type="text"
                        >
                      </div>
                      <div class="w-100 d-flex gap-1 justify-content-between">
                        <div class="w-100 modern-input-group" v-if="enotaMere !== 'kg'">
                          <input
                              :value="enotaMere === 'kg' ? ((wb.gorivo*literVKg)/lbs).toFixed(2) : ((wb.gorivo*galVliter)*literVKg).toFixed(2)"
                              class="form-control bg-warning text-dark border-light"
                              disabled
                          >
                        </div>
                        <div class="w-100 modern-input-group">
                          <input
                              :value="enotaMere === 'kg' ? (((wb.gorivo*literVKg))*arm_gorivo).toFixed(2) : ((((wb.gorivo*galVliter)*literVKg)/lbs)*arm_gorivo).toFixed(2)"
                              class="form-control border-secondary"
                              :class="{'bg-warning text-dark': enotaMere === 'kg', 'bg-dark text-light': enotaMere !== 'kg'}"
                              disabled
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Prtljaga -->
                  <div class="col-12">
                    <label class="form-label fw-bold">
                      {{ $t('obrazec.labels.ptrljaga') }} {{ enotaMere === 'kg' ? '(kg)' : '(lbs)' }}
                    </label>
                    <div class="d-flex gap-2 justify-content-between">
                      <div class="w-100 modern-input-group">
                        <input
                            v-model.number="wb.prtljaga"
                            :disabled="!lahkoIzracuna"
                            class="form-control bg-dark text-light border-secondary"
                            min="0"
                            :max="max_prtljaga"
                            placeholder="0.0"
                            step="0.1"
                            type="number"
                        >
                      </div>
                      <div class="w-100 d-flex gap-1 justify-content-between">
                        <div class="w-100 modern-input-group" v-if="enotaMere !== 'kg'">
                          <input
                              :value="enotaMere === 'kg' ? (wb.prtljaga/lbs).toFixed(2) : (wb.prtljaga*lbs).toFixed(2)"
                              class="form-control bg-warning text-dark border-light"
                              disabled
                          >
                        </div>
                        <div class="w-100 modern-input-group">
                          <input
                              :value="enotaMere === 'kg' ? ((wb.prtljaga)*arm_prtljaga).toFixed(2) : (wb.prtljaga*arm_prtljaga).toFixed(2)"
                              class="form-control border-secondary"
                              :class="{'bg-warning text-dark': enotaMere === 'kg', 'bg-dark text-light': enotaMere !== 'kg'}"
                              disabled
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer bg-dark border-secondary mt-2 d-flex justify-content-between">
                    <div class="w-100">
                      <label class="form-label fw-bold">
                        {{ $t('obrazec.labels.sTeza') }} {{ enotaMere === 'kg' ? 'kg' : 'lbs' }}
                      </label> <br/>
                      {{ enotaMere === 'kg' ? skupnaTezaKg.toFixed(2) : skupnaTeza.toFixed(2) }}
                    </div>
                    <div class="w-100 text-end" v-if="enotaMere !== 'kg'">
                      <label class="form-label fw-bold">
                        {{ $t('obrazec.labels.sTeza') }} {{ enotaMere === 'kg' ? 'lbs' : 'kg' }}
                      </label> <br/>
                      {{ enotaMere === 'kg' ? skupnaTeza.toFixed(2) : skupnaTezaKg.toFixed(2) }}
                    </div>
                    <div class="w-100 text-end">
                      <label class="form-label fw-bold">
                        {{ $t('obrazec.labels.sMoment') }}
                      </label> <br/>
                      {{ skupniMoment.toFixed(2) }}
                    </div>
                  </div>
                  <!-- Rezultati -->
                  <div
                      :class="{
                        'bg-success':
                          VrniSkupno > 0 &&
                          VrniSkupno < max_masa &&
                          Math.min(100, Math.max(0, (MasaIzracun) * 100)).toFixed(1) <= 98,

                        'bg-danger':
                          VrniSkupno > max_masa,

                        'bg-warning':
                          Math.min(100, Math.max(0, (MasaIzracun) * 100)).toFixed(1) > 98 && Math.min(100, Math.max(0, (MasaIzracun) * 100)).toFixed(1) <= 100
                      }"
                      class="alert bg-secondary text-light border-secondary mt-4 mb-0"
                  >
                    <div class="d-flex justify-content-between align-items-center gap-3">

                      <div>
                        <div class="fw-bold">
                          {{ $t('obrazec.labels.sMasa') }}
                        </div>

                        <div class="small text-light opacity-75">
                          {{ $t('obrazec.labels.maksimalno') }} {{ max_masa }} {{ enotaMere === 'kg' ? 'kg' : 'lbs' }}
                        </div>
                      </div>
                      <div>
                        <span class="fs-4 fw-bold text-light text-nowrap">
                          {{
                            enotaMere === 'kg' ? skupnaTezaKg.toFixed(2) : skupnaTeza.toFixed(2)
                          }} {{ enotaMere === 'kg' ? 'kg' : 'lbs' }}
                        </span>
                        <div class="small text-light opacity-75">
                          <!--                          {{ Math.min(100, Math.max(0, (MasaIzracun) * 100)).toFixed(1) + '%' }}-->
                          {{ (MasaIzracun * 100).toFixed(2) + '%' }}
                        </div>
                      </div>
                    </div>

                    <div class="progress mt-3 bg-dark" style="height: 8px;">
                      <div
                          class="progress-bar bg-light"
                          role="progressbar"
                          :style="{ width: Math.min(100, Math.max(0, (MasaIzracun) * 100)) + '%'}"
                      ></div>
                    </div>
                  </div>

                  <!-- moment -->
                  <!--                  <div class="alert bg-secondary text-light border-secondary mt-4 mb-0">-->
                  <!--                    <div class="d-flex justify-content-between align-items-center">-->
                  <!--                    <span class="fw-bold">-->
                  <!--                      Skupni moment-->
                  <!--                    </span>-->

                  <!--                      <span class="fs-4 fw-bold text-info"> {{ skupniMoment.toFixed(2) }} lbs </span>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!-- CG kalulacija -->
                  <div
                      :class="{
                        'bg-success':
                          VrniSkupno > 0 &&
                          (CGIzracun) >= cg_limit_min &&
                          (CGIzracun) <= cg_limit_max - 2,

                        'bg-warning':
                          VrniSkupno > 0 &&
                          (CGIzracun) > cg_limit_max - 2 &&
                          (CGIzracun) <= cg_limit_max,

                        'bg-danger':
                          VrniSkupno > 0 &&
                          (
                            (CGIzracun) < cg_limit_min ||
                            (CGIzracun) > cg_limit_max
                          )
                      }"
                      class="alert bg-secondary text-light border-secondary mt-4 mb-0"

                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="fw-bold">
                        C.G. {{ $t('obrazec.labels.kalkulacija') }}
                      </span>

                      <span class="fs-4 fw-bold text-light">
                        {{ CGIzracun.toFixed(2) }} {{ enotaMere === 'kg' ? 'mm' : 'in' }}
                      </span>
                    </div>

                    <!-- CG indikator -->
                    <div v-if="VrniSkupno" class="mt-4">

                      <div class="position-relative">

                        <!-- Osnovna linija -->
                        <div
                            class="progress bg-dark border border-light"
                            style="height: 10px;"
                        >
                          <div
                              :style="{ width: '100%'}"
                              class="progress-bar bg-light"
                              role="progressbar"
                          ></div>
                        </div>

                        <!-- Marker -->
                        <div class="position-absolute top-50 translate-middle"
                             :style="{left:  Math.min(100, Math.max(0,((CGIzracun - cg_limit_min) / (cg_limit_max - cg_limit_min)) * 100)) + '%'}"
                        >
                          <div
                              class="bg-light border border-dark rounded-circle shadow"
                              style="width: 18px; height: 18px;"
                          ></div>
                        </div>

                      </div>

                      <!-- Meje -->
                      <div class="d-flex justify-content-between mt-2 small">
                          <span>
                            {{ cg_limit_min }} {{ enotaMere === 'kg' ? 'mm' : 'in' }}
                          </span>

                        <span>
                          {{ cg_limit_max }} {{ enotaMere === 'kg' ? 'mm' : 'in' }}
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="alert alert-info d-flex align-items-center gap-2" role="alert"
                       v-if="izbranoLetalo !== null">
                    <i class="bi bi-info-circle-fill"></i>
                    <div>
                      <strong>{{
                          izbranoLetalo == null ? '' : $t('tekstwb.opozorilo', {plovilo: izbranoLetalo.registracija})
                        }}</strong><br>
                      {{ $t('tekstwb.opozorilo_podrobno') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- GRAF -->
        <div class='col-md-6 okno' v-show="lahkoIzracuna && prikaziGraf">
          <div class='card mb-4 p-4 h-100'>
            <canvas id="wb_graf" width="100" height="100"></canvas>
          </div>
        </div>
        <div class="col-md-6 okno" v-if="lahkoIzracuna && !prikaziGraf">
          <div class="alert alert-info d-flex align-items-center gap-2" role="alert"
               v-if="izbranoLetalo !== null">
            <i class="bi bi-info-circle-fill"></i>
            <div>
              <strong>{{
                  izbranoLetalo == null ? '' : $t('grafwb.opozorilo', {plovilo: izbranoLetalo.registracija})
                }}</strong><br>
              {{ $t('grafwb.opozorilo_podrobno') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <div class="w-100 mt-4 mb-4">
    <!-- ODMIK OD FOOTERJA -->
  </div>

  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @ne="ShowNoti=false"
                  @closeNotification="ShowNoti = false"/>
  </Transition>
</template>